import { schema } from "normalizr";

const PlanSchema = new schema.Entity("plans");
const PlanArraySchema = new schema.Array(PlanSchema);

export { PlanSchema, PlanArraySchema };